import { ActionBase } from '../store/ActionBase';
import { initialLoginUserData, LoginUserData, LoginUserReduceFunction } from './login-user/LoginUserData';
import {
	initialRegisterUserData,
	RegisterUserData,
	RegisterUserReduceFunction,
} from './register-user/RegisterUserData';
import { initialConnectKiyakuData, ConnectKiyakuData, ConnectKiyakuReduceFunction } from './connect/ConnectKiyakuData';
import { initialAuthorizeV1Data, AuthorizeV1Data, AuthorizeV1ReduceFunction } from './connect/AuthorizeV1Data';
import { initialAuthorizeV2Data, AuthorizeV2Data, AuthorizeV2ReduceFunction } from './connect/AuthorizeV2Data';
import { initialLoginDisplayItemData, LoginDisplayItemReduceFunction } from './connect/LoginDisplayItemData';
import { initialRedirectLoginData, RedirectLoginData, RedirectLoginReduceFunction } from './connect/RedirectLoginData';
import {
	SiteDisplayItemsExtend,
	initialSiteDisplayItemsExtendData,
	SiteDisplayItemsExtendReduceFunction,
} from './connect/SiteDisplayItemsData';
import { GetLoginDisplayItemResData } from 'requests/RequestLogin';
import {
	initialForgotPasswordData,
	ForgotPasswordData,
	ForgotPasswordReduceFunction,
} from './forgot-password/ForgotPasswordData';
import {
	initialServiceProhibitionData,
	ServiceProhibitionData,
	ServiceProhibitionReduceFunction,
} from './service-prohibition/ServiceProhibitionData';

/**
 * Store
 */
export interface Store {
	loginUserData: LoginUserData;
	registerUserData: RegisterUserData;
	connectKiyakuData: ConnectKiyakuData;
	authorizeV1Data: AuthorizeV1Data;
	authorizeV2Data: AuthorizeV2Data;
	loginDisplayItemData: GetLoginDisplayItemResData;
	siteDisplayItemsExtendData: SiteDisplayItemsExtend;
	forgotPasswordData: ForgotPasswordData;
	serviceProhibitionData: ServiceProhibitionData;
	redirectLoginData: RedirectLoginData;
}

/**
 * Storeの初期値(src\store\StoreContext.tsx以外で使用しないこと)
 */
export const initialState: Store = {
	loginUserData: initialLoginUserData,
	registerUserData: initialRegisterUserData,
	connectKiyakuData: initialConnectKiyakuData,
	authorizeV1Data: initialAuthorizeV1Data,
	authorizeV2Data: initialAuthorizeV2Data,
	loginDisplayItemData: initialLoginDisplayItemData,
	siteDisplayItemsExtendData: initialSiteDisplayItemsExtendData,
	forgotPasswordData: initialForgotPasswordData,
	serviceProhibitionData: initialServiceProhibitionData,
	redirectLoginData: initialRedirectLoginData,
};

/**
 * Reduce functions(src\store\Reducer.ts以外で使用しないこと)
 */
export const reduceFunctions: ((state: Store, action: ActionBase) => Store)[] = [
	LoginUserReduceFunction,
	RegisterUserReduceFunction,
	ConnectKiyakuReduceFunction,
	AuthorizeV1ReduceFunction,
	AuthorizeV2ReduceFunction,
	LoginDisplayItemReduceFunction,
	SiteDisplayItemsExtendReduceFunction,
	ForgotPasswordReduceFunction,
	ServiceProhibitionReduceFunction,
	RedirectLoginReduceFunction,
];
